const API_BASE = import.meta.env.VITE_API_URL || '/api'

function getHeaders(): HeadersInit {
  const token = localStorage.getItem('mazakertesh_token')
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  }
}

export async function apiGet(endpoint: string) {
  const res = await fetch(`${API_BASE}${endpoint}`, { headers: getHeaders() })
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

export async function apiPost(endpoint: string, body: any) {
  const res = await fetch(`${API_BASE}${endpoint}`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(body)
  })
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

export async function apiPut(endpoint: string, body: any) {
  const res = await fetch(`${API_BASE}${endpoint}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(body)
  })
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

export async function apiDelete(endpoint: string) {
  const res = await fetch(`${API_BASE}${endpoint}`, {
    method: 'DELETE',
    headers: getHeaders()
  })
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

// AI Services
export async function askAI(question: string, context?: string) {
  return apiPost('/ai/ask', { question, context })
}

export async function generateQuiz(topic: string, difficulty: string) {
  return apiPost('/ai/generate-quiz', { topic, difficulty })
}

export async function gradeWithAI(answer: string, question: string, rubric: string) {
  return apiPost('/ai/grade', { answer, question, rubric })
}

// Google Meet
export async function createMeeting(title: string, scheduledAt: string) {
  return apiPost('/meetings/create', { title, scheduledAt })
}

export async function getMeetingLink(meetingId: string) {
  return apiGet(`/meetings/${meetingId}/link`)
}
